export default {
    namespaced: true,
    state: {
        loggedCustomer: {},
    },
    getters: {
        // criar apenas quando necessário retornar ordenado, filtrado, etc
    },
    mutations: {
        setLoggedCustomer(state, val) {
            state.loggedCustomer = val
        },
    },
    actions: {},
}